import { useParams, useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useUser } from '../context/useUser';
import UserForm from '../components/UserForm/UserForm';
import { FormContainer } from '../components/UserForm/FormContainer';
import { FormHeader } from '../components/UserForm/FormHeader';
import { LoadingSpinner } from '../components/UserForm/LoadingSpinner';
import { ErrorSnackbar } from '../components/UserForm/ErrorSnackbar';
import { initialValues } from '../constants/userConstants';
import { createUserValidationSchema, updateUserValidationSchema } from '../validations/userValidationSchema';
import { getAttributeValue, getCnhExpirationFromAttributes, getCnhNumberFromAttributes } from '../../../utils/getAttributeLabelAndValue';
import { useAuth } from '../../auth';


export default function UserFormPage() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();
  const auth = useAuth();
  const {
    userData,
    isDataLoading,
    createUser,
    updateUser,
    isSubmitting,
    error,
    setError
  } = useUser();

  // Função para processar os dados do usuário para o formato do formulário
  const processUserDataForForm = (userData: any) => {
    if (!userData) return initialValues;

    console.log('UserFormPage - userData:', userData);
    console.log('UserFormPage - attributes:', userData.attributes);

    return {
      // Dados básicos
      name: userData.name || '',
      email: userData.email || '',
      role: userData.role || '',
      status: userData.status || '',
      phoneNumber: userData.phoneNumber || '',
      documentNumber: userData.documentNumber || '',
      description: userData.description || '',
      imageUrl: userData.imageUrl || '',
      
      // Dados dos atributos
      status_flag: getAttributeValue(userData.attributes, 'status_flag'),
      type_flag: getAttributeValue(userData.attributes, 'type_flag'),
      birth_date: getAttributeValue(userData.attributes, 'birth_date'),
      gender_flag: getAttributeValue(userData.attributes, 'gender_flag'),
      cnh_number: getAttributeValue(userData.attributes, 'cnh'),
      cnh_expiration_date: getAttributeValue(userData.attributes,'cnh_expiration_date'),
      unit: getAttributeValue(userData.attributes, 'unit'),
      section_name: getAttributeValue(userData.attributes, 'section_name'),

      password: '',
      confirmPassword: '',
      avatarFile: null,
      cnh_category: '',
    };
  };

  async function handleSubmit(formData: any) {
    try {
      const dataToSend = {
        ...formData,
        tenants: [{
          id: auth.selectedTenant.id.trim(),
          role: formData.role
        }],
      };

      console.log('handleSubmit', dataToSend);

      if (isEdit && id) {
        await updateUser(id, dataToSend);
        navigate(`/users/${id}`);
      } else {
        await createUser(dataToSend);
        navigate('/users');
      }
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
    }
  }
  function handleCancel() {
    navigate(-1);
  }

  if (isEdit && isDataLoading) {
    return (
      <FormContainer>
        <LoadingSpinner />
      </FormContainer>
    );
  }

  const formInitialValues = isEdit && userData 
    ? processUserDataForForm(userData)
    : initialValues;

  console.log('UserFormPage - formInitialValues:', formInitialValues);

  const validationSchema = isEdit ? updateUserValidationSchema : createUserValidationSchema;

  return (
    <>
      <ErrorSnackbar 
        error={error} 
        onClose={() => setError(null)} 
      />
      
      <FormContainer>
        <FormHeader mode={isEdit ? 'edit' : 'create'} />
        
        <Formik
          initialValues={formInitialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ isValid, dirty, values, errors }) => {
            console.log('Formik - values:', errors);
            return (
              <Form>
                <UserForm
                  mode={isEdit ? 'edit' : 'create'}
                  loading={isSubmitting}
                  onCancel={handleCancel}
                />
              </Form>
            );
          }}
        </Formik>
      </FormContainer>
    </>
  );
}